export default function registerScrollToDir($, apower) {
  //click and scroll to the elements
  $.registerDir("scroll-to", {
    selector: "[data-scroll-to], [data-view]",

    props: ["scroll-to", "view"],

    scrollTo: "",

    view: "",

    hasSubHeader: false,

    subHeaderHeight: 65,

    init: function () {
      this.el.$on("click", this.onClickEl, this);
      this.hasSubHeader = $(".subheader").length > 0;
    },

    onClickEl: function () {
      var cls = this.scrollTo || this.view;

      if (cls) {
        var el = $("." + cls);

        if (el.length > 0) {
          this.scrollToEl(el);
        }
      }
    },

    scrollToEl: function (el) {
      var top = el.offset().top;

      if (
        this.hasSubHeader &&
        $(window).width() > 768 &&
        top > $(window).height()
      ) {
        top -= this.subHeaderHeight;
      }

      $("html, body").animate({
        scrollTop: top,
      });
    },
  });

  //for article click and scroll to the elements
  $.registerDir("data-href-to", {
    selector: "[data-href-to]",

    props: ["href-to"],

    hrefTo: "",

    init: function () {
      this.el.$on("click", this.onClickEl, this);
    },

    onClickEl: function (e) {
      e.preventDefault();

      var cls = this.hrefTo;

      if (cls) {
        var el = $("#" + cls);

        if (el.length > 0) {
          this.scrollToEl(el);
        }
      }
    },

    scrollToEl: function (el) {
      var top = el.offset().top;
      var height = Math.max($(".header").height(), $(".subheader").height());

      top = top - height - 20;

      window.scrollTo(0, top);
    },
  });
}
